import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import RegistrationModel from './RegistrationModel';
import MailingListModel from './MailingListModel';
import Dashboard from './Dashboard';
import AccountLogin from './AccountLogin';
import { safeGet, safeRemove } from './utils/safeStorage';

function Main() {
  const apiUrl = window.location.href.includes('localhost')
    ? 'http://localhost:3001'
    : 'https://account.calibrite.com';

  // 'https://account.calibrite.com';

  const [shouldShowDashboard, setShouldShowDashboard] = useState(false);

  useEffect(() => {
    const token = safeGet('payloadToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 > Date.now()) {
          setShouldShowDashboard(true);
        } else {
          safeRemove('payloadToken');
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        safeRemove('payloadToken');
      }
    }
  }, []);

  const shouldShowResetPassword = window.location.href.includes('reset-password');
  const shouldShowUnsubscribe = window.location.href.includes('unsubscribe');
  const shouldShowProductRegistration = window.location.href.includes('register-product');
  const shouldShowAccountLogin = window.location.href.includes('login');
  const shouldShowMailingList = window.location.href.includes('mailing');

  // Check if the URL contains 'reset-password'
  if (shouldShowResetPassword || shouldShowUnsubscribe) {
    return (
      <RegistrationModel
        isOpen={true}
        onClose={() => {}}
        apiUrl={apiUrl}
        openSoftwareLicense={() => {}}
        softwareLicenseVersion={'web-demo'}
      />
    );
  }

  // Mailing list signup page
  if (shouldShowMailingList) {
    return <MailingListModel isOpen={true} onClose={() => {}} apiUrl={apiUrl} />;
  }

  // Show dashboard if user has valid token and is on login or register-product path
  if (shouldShowDashboard && (shouldShowAccountLogin || shouldShowProductRegistration)) {
    return <Dashboard isOpen={true} onClose={() => {}} apiUrl={apiUrl} />;
  }

  // Show login if on login path
  if (shouldShowAccountLogin) {
    return <AccountLogin isOpen={true} onClose={() => {}} apiUrl={apiUrl} />;
  }

  // For https://signup.calibrite.com we want all links to open to the marketing page / fallback action
  return <MailingListModel isOpen={true} onClose={() => {}} apiUrl={apiUrl} />;

  /* 
  // For development we can test the registration page without embedding within the software
  if (window.location.href.includes("mailing")) {
    return (
      <MailingListModel isOpen={true} onClose={() => {}} apiUrl={apiUrl} />
    );
  } else {
    return (
      <RegistrationModel
        isOpen={true}
        onClose={() => {}}
        apiUrl={apiUrl}
        openSoftwareLicense={() => {}}
        softwareLicenseVersion={"web-demo"}
      />
    );
  }
  */
}

export default Main;
